import React from 'react';
import cn from 'classnames';

// types
import { IFolderContextMenu } from '../../../types/studio.types';

const FolderContextMenu = ({
  isVisible,
  position,
  openFolderRenameModal,
  onProjectFolderDuplicate,
  openFolderDeleteModal,
  isFolderDuplicateLoading,
  isToolStudio,
}: IFolderContextMenu) => {
  if (!isVisible) {
    return null;
  }

  return (
    <div
      style={{ top: position.y, left: position.x }}
      className={`context-menu ${
        !isToolStudio
          ? '!bg-[#fff] !text-[#212121] dark:!text-[#eee] dark:!bg-[#3b3b3b]'
          : ''
      }`}
    >
      <button
        className={`context-menu--option ${
          !isToolStudio ? 'hover:!bg-[#eee] dark:hover:!bg-[#212121]' : ''
        }`}
        id="folder-context-menu-rename"
        onClick={openFolderRenameModal}
        type="button"
      >
        <img
          src="/static/img/icons/rename.svg"
          alt="rename"
          className={`${!isToolStudio ? 'hidden dark:block' : ''}`}
        />
        {!isToolStudio && (
          <img
            src="/static/img/icons/rename-dark.svg"
            alt="rename"
            className="w-[14px] h-[17px] block dark:hidden"
          />
        )}
        <span>Rename</span>
      </button>

      <button
        className={cn(
          `context-menu--option ${
            !isToolStudio ? 'hover:!bg-[#eee] dark:hover:!bg-[#212121]' : ''
          }`,
          {
            disabled: isFolderDuplicateLoading,
          },
        )}
        id="folder-context-menu-duplicate"
        onClick={onProjectFolderDuplicate}
        type="button"
      >
        <img
          src="/static/img/icons/copy-white.svg"
          alt="duplicate"
          className={`${!isToolStudio ? 'hidden dark:block' : ''}`}
        />
        {!isToolStudio && (
          <img
            src="/static/img/icons/copy.svg"
            alt="duplicate"
            className="w-[14px] h-[17px] block dark:hidden"
          />
        )}
        <span>{isFolderDuplicateLoading ? 'Loading ...' : 'Duplicate'}</span>
      </button>

      <button
        className={`context-menu--option ${
          !isToolStudio ? 'hover:!bg-[#eee] dark:hover:!bg-[#212121]' : ''
        }`}
        id="folder-context-menu-delete"
        onClick={openFolderDeleteModal}
        type="button"
      >
        <img
          src="/static/img/icons/delete-white.svg"
          alt="delete"
          className={`${!isToolStudio ? 'hidden dark:block' : ''}`}
        />
        {!isToolStudio && (
          <img
            src="/static/img/icons/delete.svg"
            alt="delete"
            className="w-[14px] h-[17px] block dark:hidden"
          />
        )}
        <span>Delete</span>
      </button>
    </div>
  );
};

export default FolderContextMenu;
